import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/authentication/authentication.service';

@Component({
  selector: 'app-auth-header',
  templateUrl: './auth-header.component.html',
  styleUrls: ['./auth-header.component.css']
})
export class AuthHeaderComponent implements OnInit {

  public currentUser;
  public isLogin;
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit() {
    this.isLogin = this.authenticationService.isLogin();
    this.authenticationService.getUserInfo().subscribe(data => {
      this.currentUser = data;
    });
  }

  goToGivenRoute(path, type) {
    this.router.navigate([path], {queryParams: {type}})
  }

  logout() {
    this.authenticationService.logout();
    this.isLogin = false;
    this.router.navigate(['/'])
  }


}
